{
  /* VERSION 06.01.2025/*/
}
import React, { useState, useEffect } from "react";
import {
  ChevronDown,
  Mail,
  Linkedin,
  ExternalLink,
  Award,
  Users,
  BookOpen,
  MapPin,
  Phone,
  Download,
  Calendar,
  Target,
  Beaker,
  Stethoscope,
  Brain,
  Microscope,
  Globe,
  GraduationCap,
  Building,
  Presentation,
  Lightbulb,
  Mic,
  Menu,
  X,
} from "lucide-react";

const App = () => {
  const [activeSection, setActiveSection] = useState("home");
  const [isScrolled, setIsScrolled] = useState(false);
  const [showAllPublications, setShowAllPublications] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    // Handle URL routing
    const path = window.location.pathname.slice(1) || "home";
    setActiveSection(path);
  }, []);

const navigateToSection = (section: string) => {
  setActiveSection(section);
  setIsMobileMenuOpen(false);
  window.history.pushState({}, "", `/${section === "home" ? "" : section}`);
  
  const mainContent = document.getElementById('main-content');
  if (mainContent) {
    const headerHeight = 100; // Adjust this value to account for your fixed banner
    const elementPosition = mainContent.offsetTop - headerHeight;
    
    window.scrollTo({
      top: elementPosition,
      behavior: 'smooth'
    });
  }
};

const allPublications = [

  {
  title: "Painful Neuromas Exhibit Axonal Phenotypic Shift via Nociceptive and Mechanosensitive Marker Upregulation",
  authors: "Tereshenko V, Raasveld FV, Hwang CD, et al.",
  journal: "PNAS Nexus",
  year: "2026",
  link: "https://pubmed.ncbi.nlm.nih.gov/42582843/",
  status: ["Highlighted"],
},
    {
  title: "A Comparison of Treatment Outcomes of Partial and Complete Radial Collateral Ligament Tears of the Index and Long finger",
  authors: "Freundt L, Legerstee, IWF, Raasveld FV, et al.",
  journal: "Hand Surgery and Rehabilitation",
  year: "2026",
  link: "https://pubmed.ncbi.nlm.nih.gov/42805433/",
  status: "",
},
    {
  title: "Primary vs. Secondary Targeted Muscle Reinnervation in Amputees: A Long-Term Comparative Analysis of Pain Trajectories",
  authors: "Raasveld FV, Mayrhofer-Schmid M, Van Varsseveld OC, et al.",
  journal: "Journal of Plastic, Reconstructive & Aesthetic Surgery",
  year: "2026",
  link: "https://www.jprasurg.com/article/S1748-6815(26)00542-5/fulltext",
  status: ["ICOPLAST Special Edition"],
},
   {
  title: "Assessment of Diagnostic Criteria for Centralized Pain in Amputees Undergoing Secondary Targeted Muscle Reinnervation",
  authors: "Tiems MRA, Raasveld FV, Johnston BR, et al.",
  journal: "Journal of Plastic, Reconstructive & Aesthetic Surgery",
  year: "2026",
  link: "https://pubmed.ncbi.nlm.nih.gov/42647971/",
  status: "",
},
  {
  title: "Emergency Free Flap Reconstruction in Traumatic Extremity Injuries: Clinical Indications and Framework",
  authors: "Moussa O, Chansomboon J, Raasveld FV, et al.",
  journal: "Microsurgery",
  year: "2026",
  link: "https://pubmed.ncbi.nlm.nih.gov/42415291/",
  status: "",
},
{
  title: "Targeted Muscle Reinnervation for Management and Prevention of Symptomatic Neuroma",
  authors: "Raasveld FV, Mayrhofer-Schmid M, Johnston BR, et al.",
  journal: "Muscle & Nerve",
  year: "2026",
  link: "https://pubmed.ncbi.nlm.nih.gov/42400435/",
  status: "",
},
  {
  title: "Algorithm for Surgical Management of Symptomatic Hand and Digital Neuromas",
  authors: "Mayrhofer-Schmid M, Nieuwdorp N, Clegg D, et al.",
  journal: "Plastic and Reconstructive Surgery – Global Open",
  year: "2026",
  link: "https://pubmed.ncbi.nlm.nih.gov/42344267/",
  status: "",
}, 
  {
  title: "Rethinking “Benign” in Counseling Prior to Peripheral Nerve Sheath Tumor Surgery",
  authors: "Hanna T, Raasveld FV, Eberlin KR, et al.",
  journal: "Plastic and Reconstructive Surgery",
  year: "2026",
  link: "https://pubmed.ncbi.nlm.nih.gov/42202077/",
},  
  {
  title: "“Painless Palsy” Revisited: A Systematic Review of Pain in Hereditary Neuropathy with Liability to Pressure Palsies",
  authors: "Raasveld FV, Pacheco FJ, Rao AS, et al.",
  journal: "Pain Management",
  year: "2026",
  link: "https://pubmed.ncbi.nlm.nih.gov/42165586/",
},
  {
  title: "Defining Orthoplastic Limb Salvage Centers: A Systematic Review",
  authors: "Moussa O*, Pacheco FJ*, Raasveld FV, et al.",
  journal: "Archives of Orthopaedic and Trauma Surgery",
  year: "2026",
  link: "https://pubmed.ncbi.nlm.nih.gov/42069968/",
},
  {
  title: "Long-term Outcomes of Symptomatic Neuromas in the Wrist, Hand, and Digits: A Prospective Cohort Study",
  authors: "Raasveld FV, Nieuwdorp NJ, Van der Avoort DJJC, et al.",
  journal: "Journal of Plastic, Reconstructive & Aesthetic Surgery",
  year: "2026",
  link: "https://pubmed.ncbi.nlm.nih.gov/41903415/",
},
  {
  title: "Benign Peripheral Nerve Sheath Tumors: Recurrence Rates and Pain Outcomes Following Excision",
  authors: "Raasveld FV, Hanna T, Pacheco F, et al.",
  journal: "Plastic and Reconstructive Surgery",
  year: "2026",
  link: "https://pubmed.ncbi.nlm.nih.gov/41874286/",
},
  {
  title: "Orthoplastic Limb Salvage Centers: A Survey to Determine Essential Components and Framework for Implementation",
  authors: "Moussa O, Caragher SP, Raasveld FV, et al.",
  journal: "Journal of Reconstructive Microsurgery",
  year: "2026",
  link: "https://pubmed.ncbi.nlm.nih.gov/41734816/",
},
  {
  title: "Psychosocial Outcomes Following Targeted Muscle Reinnervation in Patients with Neuropathic Pain",
  authors: "Raasveld FV, Yu T-H, Ho J, et al.",
  journal: "Pain Medicine",
  year: "2026",
  link: "https://pubmed.ncbi.nlm.nih.gov/41652895/",
},
  {
  title: "Revision Targeted Muscle Reinnervation for Management of Neuropathic Pain in Lower Extremity Amputees",
  authors: "Raasveld FV, Tiems MRA, Mayrhofer-Schmid M, et al.",
  journal: "Journal of Plastic, Reconstructive & Aesthetic Surgery",
  year: "2026",
  link: "https://pubmed.ncbi.nlm.nih.gov/41747479/",
},
  {
  title: "Machine Learning Approach to Predict Pain Outcomes Following Primary and Secondary Targeted Muscle Reinnervation in Amputees",
  authors: "Raasveld FV, Zhang Z, Johnston BR, et al.",
  journal: "Plastic and Reconstructive Surgery",
  year: "2026",
  link: "https://pubmed.ncbi.nlm.nih.gov/41628603/",
  status: "Highlighted",
},
  {
  title: "Machine Learning and Computer Vision for Detection and Classification of Pain in Lower Extremity Amputees",
  authors:"Rao AS, Raasveld FV, Moussa O, et al.",
  journal: "Journal of Plastic, Reconstructive & Aesthetic Surgery",
  year: "2026",
  link: "https://pubmed.ncbi.nlm.nih.gov/41558099/",
  status: "Highlighted",
},
  {
  title: "Evolution of a Specialized Multidisciplinary Amputee Care Clinic: Referral Patterns and Patient Satisfaction",
  authors: "Raasveld FV, Moussa O, van Varsseveld OC, et al.",
  journal: "Research Square",
  year: "2026",
  link: "https://doi.org/10.21203/rs.3.rs-8289177/v1",
  status: ["Preprint"],
},
  {
  title: "Personal Financial Burden Following Distal Upper Extremity Nerve Injury",
  authors: "Moussa O, Raasveld FV, Amin K, et al.",
  journal: "Plastic and Reconstructive Surgery",
  year: "2025",
  link: "https://journals.lww.com/plasreconsurg/abstract/9900/personal_financial_burden_following_distal_upper.2920.aspx",
},
  {
    title: "A Reference Atlas of the Human Dorsal Root Ganglion",
    authors: "Bhuiyan SA, Nagi SS, Sankaranarayanan I, et al; NIH PRECISION Human Pain Network** (**Consortium contributor)",
    journal: "bioRxiv",
    year: "2025",
    link: "https://pubmed.ncbi.nlm.nih.gov/41279342/",
    status: ["Preprint", "Highlighted"],
},
  {
    title:
      "Diagnostic Criteria for Centralized Pain Following Peripheral Nerve Injury: A Systematic Review",
    authors: "Raasveld FV*, Tiems MRA*, Johnston BR, et al (*co-first authors)",
    journal: "The Clinical Journal of Pain",
    year: "2025",
    link: "https://pubmed.ncbi.nlm.nih.gov/40977364/",
  },
  {
    title:
      "Reply to: Letter re: Targeted Muscle Reinnervation for Treatment of Neuropathic Pain in Non-Amputees – Indications and Outcomes",
    authors: "Raasveld FV, Eberlin KR",
    journal: "Journal of Plastic, Reconstructive & Aesthetic Surgery",
    year: "2025",
    link: "https://pubmed.ncbi.nlm.nih.gov/40957820/",
  },
   {
    title:
      "Combined Use of Peripheral Nerve Surgery and Peripheral Nerve Stimulation in Patients with Refractory Neuropathic Pain",
    authors: "Raasveld FV, Johnston BR, Hao D, Valerio IL, Eberlin KR",
    journal: "Microsurgery",
    year: "2025",
    link: "https://pubmed.ncbi.nlm.nih.gov/40899988/",
  },
  {
    title:
      "Peripheral Nerve Surgery in Patients with a Label of Complex Regional Pain Syndrome in the Extremities",
    authors: "Raasveld FV*, Wolff M*, Luan A, et al. (*co-first authors)",
    journal: "Journal of the American College of Surgeons",
    year: "2025",
    link: "https://pubmed.ncbi.nlm.nih.gov/40815056/",
  },
  {
    title:
      "Perception and reality of robotic microsurgery: a cross-sectional comparative user and non-user survey study",
    authors: "Mayrhofer-Schmid M, Aman M, Raasveld FV, et al.",
    journal: "Plastic and Reconstructive Surgery – Global Open",
    year: "2025",
    link: "https://pubmed.ncbi.nlm.nih.gov/40524882/",
  },
  {
    title: "Factors Associated with Length of Stay in Lower Extremity Free Flap Reconstruction",
    authors: "Moussa O, Raasveld FV, Fruge S, et al.",
    journal: "Plastic and Reconstructive Surgery",
    year: "2025",
    link: "https://pubmed.ncbi.nlm.nih.gov/40663765/",
  },
  {
    title:
      "Human pain neuroscience and the next generation of pain therapeutics",
    authors:
      "Copits BA, Curatolo M, Dougherty PM, et al, NIH PRECISION Human Pain Network** (**Consortium contributor)",
    journal: "Neuron",
    year: "2025",
    link: "https://pubmed.ncbi.nlm.nih.gov/40339567/",
    status: "Highlighted",
  },
  {
    title:
      "Surgical management of peripheral nerve symptoms following knee arthroplasty",
    authors:
      "Van Varsseveld OC*, Raasveld FV*, Liu WC, et al. (*co-first authors)",
    journal: "Arthroplasty",
    year: "2025",
    link: "https://pubmed.ncbi.nlm.nih.gov/40474318/",
  },
  {
    title:
      "Targeted Muscle Reinnervation for Treatment of Neuropathic Pain in Non-Amputees – Indications and Outcomes",
    authors:
      "Raasveld FV*, van Varsseveld OC*, Hundepool CA, et al. (*co-first authors)",
    journal: "Journal of Plastic, Reconstructive & Aesthetic Surgery",
    year: "2025",
    link: "https://pubmed.ncbi.nlm.nih.gov/40344808/",
  },
  {
    title:
      "Vibrotactile Stimulation in Lower Extremity Amputation Patients Using a Noninvasive Vibration Device: A Pilot Study",
    authors: "Raasveld FV, Daddario J, Liu WC, et al.",
    journal: "Plastic and Reconstructive Surgery – Global Open",
    year: "2025",
    link: "https://pubmed.ncbi.nlm.nih.gov/40391346/",
  },
  {
    title:
      "Complex Regional Pain Syndrome: Navigating Diagnostic Complexities",
    authors:
      "Raasveld FV*, Wolff M*, Luan A, Hao D, Valerio IL, Eberlin KR (*co-first authors)",
    journal: "The Clinical Journal of Pain",
    year: "2025",
    link: "https://pubmed.ncbi.nlm.nih.gov/40211731/",
  },
  {
    title: "Sequential Free Flaps in Lower Extremity Reconstruction",
    authors:
      "Huang DW, Raasveld FV, Moussa O, Tuaño K, Valerio IL, Eberlin KR",
    journal: "Journal of Plastic, Reconstructive & Aesthetic Surgery Open",
    year: "2025",
    link: "https://pubmed.ncbi.nlm.nih.gov/40235840/",
  },
  {
    title:
      "ASO Visual Abstract: Neuropathic Pain Following Surgery for Malignant Peripheral Nerve Sheath Tumors",
    authors: "Raasveld FV, Hanna T, Pacheco FJ, et al.",
    journal: "Annals of Surgical Oncology",
    year: "2025",
    link: "https://link.springer.com/article/10.1245/s10434-025-17226-8",
  },
  {
    title:
      "Perioperative Pain Management for Major Limb Amputation - A Systematic-Narrative Hybrid Review",
    authors: "Raasveld FV, Caragher SP, Kumar N, et al.",
    journal: "Current Pain and Headache Reports",
    year: "2025",
    link: "https://pubmed.ncbi.nlm.nih.gov/40095222/",
  },
  {
    title:
      "ASO Author Reflections: Neuropathic Pain-A Persistent Challenge Following Surgical Resection of Malignant Peripheral Nerve Sheath Tumors",
    authors: "Raasveld FV, Hanna T, Pacheco FJ, et al.",
    journal: "Annals of Surgical Oncology",
    year: "2025",
    link: "https://pubmed.ncbi.nlm.nih.gov/40057647/",
  },
  {
    title: "Reimbursement for neuroma surgery over the past decade",
    authors: "Stearns SA, Raizman NM, Raasveld FV, et al.",
    journal: "Annals of Plastic Surgery",
    year: "2025",
    link: "https://pubmed.ncbi.nlm.nih.gov/39970074/",
  },
  {
    title:
      "Neuropathic Pain Following Surgery for Malignant Peripheral Nerve Sheath Tumors",
    authors: "Raasveld FV, Hanna T, Pacheco FJ, et al.",
    journal: "Annals of Surgical Oncology",
    year: "2025",
    link: "https://pubmed.ncbi.nlm.nih.gov/39987385/",
  },
  {
    title:
      "The influence of nerve surgical techniques at time of amputation on the prevalence of heterotopic ossification in transtibial amputees",
    authors: "Raasveld FV, Lehle CH, Hwang CD, et al.",
    journal: "Injury",
    year: "2024",
    link: "https://pubmed.ncbi.nlm.nih.gov/39608134/",
    status: "Highlighted",
  },
  {
    title:
      "Nerve graft reconstruction of irradiated oncologic segmental nerve defects in the extremities: A case series",
    authors: "Hoftiezer YAJ, Raasveld FV, Werenski JO, et al.",
    journal: "Surgical Oncology Insight",
    year: "2024",
    link: "https://www.sciencedirect.com/science/article/pii/S2950247024000987",
  },
  {
    title:
      "Tendinopathy of the distal biceps tendon is a common incidental finding on magnetic resonance imaging of the elbow",
    authors:
      "Tuik CK, Cross RE, Hoftiezer YAJ, Raasveld FV, Van Den Bekerom MPJ, Chen NC",
    journal: "The Archives of Bone and Joint Surgery",
    year: "2024",
    link: "https://pubmed.ncbi.nlm.nih.gov/39478842/",
  },
  {
    title:
      "Neuropathic pain after major limb amputation: A cross-sectional study",
    authors: "Langeveld M, Raasveld FV, Hundepool CA, et al.",
    journal: "Plastic and Reconstructive Surgery",
    year: "2024",
    link: "https://pubmed.ncbi.nlm.nih.gov/38857429/",
  },
  {
    title:
      "Fibrin glue coating limits scar tissue formation around peripheral nerves",
    authors:
      "Mayrhofer-Schmid M, Aman M, Panayi AC, Raasveld FV, Kneser U, Eberlin KR, Harhaus L, Böcker A",
    journal: "International Journal of Molecular Sciences",
    year: "2024",
    link: "https://pubmed.ncbi.nlm.nih.gov/38612497/",
  },
  {
    title:
      "Pain remission following delayed targeted muscle reinnervation in amputees",
    authors:
      "Raasveld FV, Mayrhofer-Schmid M, Johnston BR, Hwang CD, Valerio IL, Eberlin KR",
    journal: "Microsurgery",
    year: "2024",
    link: "https://pubmed.ncbi.nlm.nih.gov/39545514/",
    status: "Highlighted",
  },
  {
    title:
      "Early postoperative pain course following primary and secondary targeted muscle reinnervation: A temporal description of pain outcomes",
    authors: "Raasveld FV, Hoftiezer YAJ, Gomez-Eslava B, et al.",
    journal: "Journal of Reconstructive Microsurgery",
    year: "2024",
    link: "https://pubmed.ncbi.nlm.nih.gov/39191418/",
  },
  {
    title:
      "Evaluation of MRI features of neuromas in oncological amputees, and the relation to pain",
    authors: "Van Vliet E, Raasveld FV, Liu WC, et al.",
    journal: "Skeletal Radiology",
    year: "2024",
    link: "https://pubmed.ncbi.nlm.nih.gov/39264418/",
  },
  {
    title:
      "Anatomy of Lister's tubercle: Implications for volar locked plating of the distal radius",
    authors:
      "Laane CLE*, Raasveld FV*, de Klerk HH, et al. (*co-first authors)",
    journal: "HAND",
    year: "2024",
    link: "https://pubmed.ncbi.nlm.nih.gov/39469874/",
  },
  {
    title: "Neuroma morphology: A macroscopic classification system",
    authors: "Raasveld FV, Weigel DT, Liu W, et al.",
    journal: "Muscle & Nerve",
    year: "2024",
    link: "https://pubmed.ncbi.nlm.nih.gov/39295574/",
  },
  {
    title: "Neuroma-to-nerve ratio: Does size matter?",
    authors: "Weigel DT, Raasveld FV, Liu WC, et al.",
    journal: "Neurosurgery",
    year: "2024",
    link: "https://pubmed.ncbi.nlm.nih.gov/39248535/",
  },
  {
    title:
      "Targeted muscle reinnervation at the time of amputation to prevent the development of neuropathic pain",
    authors: "Raasveld FV, Mayrhofer-Schmid M, Johnston BR, et al.",
    journal: "Journal of Plastic, Reconstructive & Aesthetic Surgery",
    year: "2024",
    link: "https://pubmed.ncbi.nlm.nih.gov/39121547/",
    status: "Highlighted",
  },
  {
    title:
      "The neuroma map: A systematic review of the anatomic distribution, etiologies, and surgical treatment of painful traumatic neuromas",
    authors: "Remy K*, Raasveld FV*, Saqr H, et al. (*co-first authors)",
    journal: "Surgery",
    year: "2024",
    link: "https://pubmed.ncbi.nlm.nih.gov/39025690/",
  },
  {
    title:
      "Social deprivation is associated with increased pain in patients presenting with neuropathic pain",
    authors: "Raasveld FV, Lans J, Valerio IL, Eberlin KR",
    journal: "Plastic and Reconstructive Surgery – Global Open",
    year: "2024",
    link: "https://pubmed.ncbi.nlm.nih.gov/39148658/",
  },
  {
    title:
      "Predictive value of preoperative pain sketches in lower extremity amputees undergoing secondary targeted muscle reinnervation for treatment of neuropathic pain",
    authors:
      "Raasveld FV, Hao D, Gomez-Eslava B, Hwang CD, Valerio IL, Eberlin KR",
    journal: "Journal of the American College of Surgeons",
    year: "2024",
    link: "https://pubmed.ncbi.nlm.nih.gov/38920300/",
    status: "Highlighted",
  },
  {
    title:
      "Neuroma analysis in humans: Standardizing sample collection and documentation",
    authors: "Raasveld FV, Liu WC, Mayrhofer-Schmid M, et al.",
    journal: "The Journal of Surgical Research",
    year: "2024",
    link: "https://pubmed.ncbi.nlm.nih.gov/38626715/",
    status: "Highlighted",
  },
  {
    title:
      "Three useful tips and tricks for intraoperative nerve stimulation",
    authors:
      "Liu WC*, Raasveld FV*, Mayrhofer-Schmid M, Eberlin KR, Valerio IL (*co-first authors)",
    journal: "Plastic and Reconstructive Surgery – Global Open",
    year: "2024",
    link: "https://pubmed.ncbi.nlm.nih.gov/38463708/",
  },
  {
    title:
      "Discussion: Symptomatic neuroma development following en bloc resection of skeletal and soft-tissue tumors",
    authors: "Raasveld FV, Eberlin KR",
    journal: "Plastic and Reconstructive Surgery",
    year: "2024",
    link: "https://pubmed.ncbi.nlm.nih.gov/38546361/",
  },
  {
    title:
      "Heterotopic ossification is associated with painful neuromas in transtibial amputees undergoing surgical treatment of symptomatic neuromas",
    authors:
      "Raasveld FV, Liu WC, Renthal W, Fleming ME, Valerio IL, Eberlin KR",
    journal: "Plastic and Reconstructive Surgery",
    year: "2024",
    link: "https://pubmed.ncbi.nlm.nih.gov/38507565/",
  },
  {
    title:
      "Pain sketches to predict pain following primary targeted muscle reinnervation in amputees",
    authors: "Gomez-Eslava B, Raasveld FV, Hoftiezer YAJ, et al.",
    journal: "Plastic and Reconstructive Surgery",
    year: "2024",
    link: "https://pubmed.ncbi.nlm.nih.gov/37252909/",
  },
  {
    title: "Biology and pathophysiology of symptomatic neuromas",
    authors: "Hwang CD, Hoftiezer YAJ, Raasveld FV, et al.",
    journal: "PAIN",
    year: "2023",
    link: "https://pubmed.ncbi.nlm.nih.gov/37851396/",
    status: "Highlighted",
  },
  {
    title:
      "The peripheral nerve surgeon's role in the management of neuropathic pain",
    authors: "Caragher SP, Khouri KS, Raasveld FV, et al.",
    journal: "Plastic and Reconstructive Surgery – Global Open",
    year: "2023",
    link: "https://pubmed.ncbi.nlm.nih.gov/37360238/",
  },
];

  const achievements = [
    {
      number: "50+",
      label: "Publications",
      icon: <BookOpen className="w-6 h-6" />,
      description: "Peer-reviewed research",
    },
    {
      number: "$15M",
      label: "NIH Study Contributor",
      icon: <Target className="w-6 h-6" />,
      description: "Multicenter collaboration",
    },
    {
      number: "70+",
      label: "Conference Presentations",
      icon: <Users className="w-6 h-6" />,
      description: "International speaking",
    },
    {
      number: "5+",
      label: "Site Collaboration",
      icon: <Globe className="w-6 h-6" />,
      description: "Cross-institutional work",
    },
  ];

  const expertise = [
    {
      title: "Clinical Research",
      description:
        "Contributing to multicenter pain studies with expertise in clinical trial design, regulatory compliance, and evidence synthesis.",
      icon: <Stethoscope className="w-8 h-8" />,
      skills: [
        "GCP & Regulatory Compliance",
        "Protocol Development",
        "Cross-functional Collaboration",
        "Clinical Trial Design",
      ],
    },

    {
      title: "Advanced Analytics",
      description:
        "Developing machine learning models, ICAN algorithms, and digital tools for precision medicine and clinical decision support.",
      icon: <Microscope className="w-8 h-8" />,
      skills: [
        "Machine Learning/AI & ICAN Algorithms",
        "Biostatistics (R, Stata, Python)",
        "Medical Device Development",
        "Digital Clinical Tools",
      ],
    },

    {
      title: "Translational Foundations",
      description:
        "Experience in trial design, pharmacovigilance, stakeholder engagement, and regulatory science foundation.",
      icon: <Lightbulb className="w-8 h-8" />,
      skills: [
        "Stakeholder Engagement",
        "Pharmacovigilance",
        "Trial deisgn",
        "Regulatory Science (Foundational)",
      ],
    },
  ];

  const globalExperience = [
    {
      country: "Netherlands",
      role: "Medical Education and Public Health",
      institution: "University of Groningen, Erasmus University Rotterdam, Public Health Service",
      description:
        "MD training, PhD (In Progress), Pharmacy (Propedeutics), COVID-19 vaccination campaigns and emergency care, neuropathic pain research",
      flag: "🇳🇱",
      years: "2013-2022",
    },
    {
      country: "Curaçao",
      role: "Medical Training & International Clinical Experience",
      institution: "Curaçao Medical Center",
      description:
        "MD training, hospital pharmacy reorganization, COVID-19 response team initiation",
      flag: "🇨🇼",
      years: "2019-2020",
    },
    {
      country: "United States",
      role: "Doctoral Education and Research",
      institution: "Massachusetts General Hospital, Harvard Medical School",
      description:
        "NIH HEAL Initiative contributor, ICAN Research, multidisciplinary team coordination, neuropathic pain research",
      flag: "🇺🇸",
      years: "2022-2026",
    },
  ];

  const renderMainContent = () => {
    switch (activeSection) {
      case "home":
        return (
          <>
            <div className="bg-white py-16 px-6">
              <div className="max-w-6xl mx-auto">
                <div className="text-center mb-12">
                  <h2 className="text-3xl font-bold text-slate-900 mb-6">
                    What Drives Me
                  </h2>
                  <p className="text-lg text-slate-600 max-w-4xl mx-auto leading-relaxed">
                    Passionate about bridging clinical research and industry
                    applications through evidence-based medicine and
                    collaborative therapeutic development
                  </p>
                </div>

                <div className="grid grid-cols-2 lg:grid-cols-4 gap-8 mb-16">
                  {achievements.map((achievement, index) => (
                    <div key={index} className="text-center">
                      <div className="inline-flex items-center justify-center w-16 h-16 bg-blue-100 rounded-xl mb-4 hover:-translate-y-1 transition-transform duration-300">
                        <div className="text-blue-600">{achievement.icon}</div>
                      </div>

                      <div className="text-3xl font-bold text-slate-900 mb-2">
                        {achievement.number}
                      </div>
                      <div className="text-blue-600 font-medium mb-1">
                        {achievement.label}
                      </div>
                      <div className="text-sm text-slate-500">
                        {achievement.description}
                      </div>
                    </div>
                  ))}
                </div>

                <div>
                  <h3 className="text-2xl font-bold text-slate-900 mb-8 text-center">
                    Specialized Focus
                  </h3>
                  <div className="grid lg:grid-cols-3 gap-8">
                    {expertise.map((area, index) => (
                      <div
                        key={index}
                        className="bg-slate-50 rounded-xl p-6 border border-slate-200"
                      >
                        <div className="flex items-center space-x-4 mb-4">
                          <div className="p-2 bg-white rounded-lg border border-slate-200">
                            <div className="text-blue-600">{area.icon}</div>
                          </div>
                          <h4 className="text-lg font-semibold text-slate-900">
                            {area.title}
                          </h4>
                        </div>
                        <p className="text-slate-600 mb-4 text-sm leading-relaxed">
                          {area.description}
                        </p>
                        <div className="space-y-2">
                          {area.skills.map((skill, skillIndex) => (
                            <div
                              key={skillIndex}
                              className="flex items-center space-x-2"
                            >
                              <div className="w-1.5 h-1.5 bg-slate-400 rounded-full"></div>
                              <span className="text-xs text-slate-600">
                                {skill}
                              </span>
                            </div>
                          ))}
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </>
        );

case "about":
  return (
    <div className="bg-slate-50 py-16 px-6">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold text-slate-900 mb-4">
            Professional Background
          </h2>
          <p className="text-lg text-slate-600 max-w-3xl mx-auto">
            International clinical and research experience spanning three
            countries with focus on surgical and interventional pain
            medicine, regulatory compliance, and cross-functional research
            leadership.
          </p>
        </div>

        <div className="mb-12">
          <h3 className="text-2xl font-bold text-slate-900 mb-8 text-center">
            International Experience
          </h3>
          <div className="grid md:grid-cols-3 gap-6">
            {globalExperience.map((exp, index) => (
              <div
                key={index}
                className="bg-white rounded-xl p-6 border border-slate-200"
              >
                <div className="text-center">
                  <div className="text-3xl mb-3">{exp.flag}</div>
                  <h4 className="font-bold text-slate-900 mb-1">
                    {exp.country}
                  </h4>
                  <p className="font-medium text-blue-600 mb-2 text-sm">
                    {exp.role}
                  </p>
                  <p className="text-xs text-slate-600 mb-2">
                    {exp.institution}
                  </p>
                  <p className="text-xs text-slate-500 mb-3">{exp.years}</p>
                  <p className="text-sm text-slate-700">{exp.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="mb-12">
          <h3 className="text-2xl font-bold text-slate-900 mb-8 text-center">
            Industry Foundation
          </h3>

          <div className="grid md:grid-cols-2 gap-6">           
            {/* Propaedeutic Degree in Pharmacy */}
            <div className="bg-white rounded-xl p-6 border border-slate-200">
              <div className="flex items-center space-x-3 mb-4">
                <GraduationCap className="w-6 h-6 text-blue-600" />
                <div>
                  <h4 className="font-semibold text-slate-900">
                    Propaedeutic Degree in Pharmacy
                  </h4>
                  <p className="text-sm text-slate-600">
                    University of Groningen, Netherlands – 2015
                  </p>
                </div>
              </div>
              <p className="text-sm text-slate-700">
                Foundational training in pharmaceutical sciences, including pharmacokinetics, pharmacodynamics, drug development, and molecular therapeutics.
              </p>
            </div>
            
            {/* Industry Experience */}
            <div className="bg-white rounded-xl p-6 border border-slate-200">
              <div className="flex items-center space-x-3 mb-4">
                <Beaker className="w-6 h-6 text-blue-600" />
                <div>
                  <h4 className="font-semibold text-slate-900">
                    Medical Research Associate
                  </h4>
                  <p className="text-sm text-slate-600">
                    PRA Health Sciences (ICON CRO) – 2017–2018
                  </p>
                </div>
              </div>
              <p className="text-sm text-slate-700">
                Phase I–II clinical trial monitoring, GCP compliance, pharmacovigilance, and participant safety monitoring across multiple therapeutic areas.
              </p>
            </div>

            {/* Industry Licenses */}
            <div className="bg-white rounded-xl p-6 border border-slate-200">
              <div className="flex items-center space-x-3 mb-4">
                <Award className="w-6 h-6 text-blue-600" />
                <div>
                  <h4 className="font-semibold text-slate-900">
                    Industry Licenses
                  </h4>
                  <p className="text-sm text-slate-600">BCMAS & RAPS FRA – 2025</p>
                </div>
              </div>
              <p className="text-sm text-slate-700">
                Board Certified Medical Affairs Specialist (BCMAS): Certification in medical affairs strategy, stakeholder engagement, and scientific communication.
              </p>
              <p className="text-sm text-slate-700 mt-2">
                Foundation in Regulatory Affairs (RAPS): Regulatory science for medical devices and pharmaceuticals, covering FDA/EMA pathways and compliance.
              </p>
            </div>

            {/* MBA Program */}
            <div className="bg-white rounded-xl p-6 border border-slate-200">
              <div className="flex items-center space-x-3 mb-4">
                <GraduationCap className="w-6 h-6 text-blue-600" />
                <div>
                  <h4 className="font-semibold text-slate-900">
                    Master of Business Administration (MBA)
                  </h4>
                  <p className="text-sm text-slate-600">
                    Western Governors University – 2025 
                  </p>
                </div>
              </div>
              <p className="text-sm text-slate-700">
                MBA program focused on leadership, strategy, and decision-making, using case studies in healthcare, biotech, and business management.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );


      case "research":
        return (
          <div className="py-16 px-6">
            <div className="max-w-6xl mx-auto">
              <div className="text-center mb-12">
                <h2 className="text-3xl font-bold text-slate-900 mb-4">
                  Research Contributions
                </h2>
                <p className="text-lg text-slate-600 max-w-3xl mx-auto">
                  Contributing to advancing pain medicine through clinical
                  research, regulatory science, and evidence-based therapeutic
                  development.
                </p>
              </div>

              {/* NIH HEAL Initiative */}
              <div className="bg-slate-50 border border-slate-200 rounded-xl p-8 mb-12 shadow">
                <div className="flex items-center space-x-4 mb-6">
                  <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center">
                    <Target className="w-6 h-6 text-blue-600" />
                  </div>
                  <div>
                    <h3 className="text-xl font-bold">
                      NIH HEAL Initiative Contributor
                    </h3>
                    <p className="text-blue-800">
                      $15M Multicenter Neuropathic Pain Study
                    </p>
                  </div>
                </div>
                <p className="text-blue-800 mb-6">
                  Contributing researcher in a collaborative effort across 5+
                  clinical sites investigating neuroma biology and neuropathic
                  pain mechanisms. Part of the{" "}
                  <a
                    href="https://healpain.bwh.harvard.edu/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="underline hover:text-black"
                  >
                    Precision Pain Center
                  </a>
                  , alongside investigators at Boston Children&apos;s Hospital,
                  Brigham and Women&apos;s Hospital, University of Pennsylvania,
                  University of Texas Dallas, and Washington University in St.
                  Louis.
                </p>
                <div className="grid md:grid-cols-3 gap-4">
                  <div className="bg-white/10 rounded-lg p-4">
                    <div className="text-lg font-bold">5+ Sites</div>
                    <div className="text-blue-800 text-sm">
                      Clinical Collaboration
                    </div>
                  </div>
                  <div className="bg-white/10 rounded-lg p-4">
                    <div className="text-lg font-bold">Tissue Core</div>
                    <div className="text-blue-800 text-sm">Management Role</div>
                  </div>
                  <div className="bg-white/10 rounded-lg p-4">
                    <div className="text-lg font-bold">2022–2027</div>
                    <div className="text-blue-800 text-sm">Study Duration</div>
                  </div>
                </div>
              </div>

              {/* ICAN Platform Section */}
              <div className="bg-slate-50 border border-slate-200 rounded-xl p-8 mb-12 shadow">
                <div className="flex items-center space-x-4 mb-4">
                  <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center">
                    <Lightbulb className="w-6 h-6 text-blue-600" />
                  </div>
                  <div>
                    <h3 className="text-xl font-bold text-blue-900">
                      ICAN Algorithms
                    </h3>
                    <p className="text-blue-700 text-sm">
                      Clinical Innovation Tools for Surgical Decision-Making
                    </p>
                  </div>
                </div>
                <p className="text-blue-800 mb-4">
                  Part of the Interdisciplinary Care for Amputee Network (ICAN)
                  at the Massachusetts General Hospital. Clinical algorithms and
                  decision aids created to support evidence-based care for
                  patients with neuropathic pain and amputations.
                </p>
                <a
                  href="https://icanalgorithms.netlify.app/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center space-x-2 bg-blue-600 text-white px-5 py-2 rounded-lg hover:bg-blue-700 transition-colors font-medium hover:-translate-y-0.5 transition-transform duration-300"
                >
                  <Lightbulb className="w-5 h-5" />
                  <span>Explore ICAN Algorithms</span>
                </a>
              </div>

              {/* Conference Speaking & Awards */}
              <div className="bg-slate-50 border border-slate-200 rounded-xl p-8 mb-12 shadow">
                <div className="flex items-center space-x-4 mb-6">
                  <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center">
                    <Mic className="w-6 h-6 text-blue-600" />
                  </div>
                  <div>
                    <h3 className="text-xl font-bold text-blue-900">
                      Conference Speaking
                    </h3>
                    <p className="text-blue-700 text-sm">
                      70+ podium presentations
                    </p>
                  </div>
                </div>

                <div>
                  <div className="grid grid-cols-2 gap-x-8 mb-2 text-blue-800 text-sm font-medium">
                    <ul className="list-disc pl-6 space-y-1">
                      <li>American Society of Plastic Surgeons (ASPS)</li>
                      <li>American Society for Peripheral Nerve (ASPN)</li>
                      <li>American Academy of Orthopaedic Surgeons (AAOS)</li>
                    </ul>
                    <ul className="list-disc pl-6 space-y-1">
                      <li>American Society for Surgery of the Hand (ASSH)</li>
                      <li>IFSSH - Global Hand Congress</li>
                      <li>FESSH - European Hand Congress</li>
                    </ul>
                  </div>
                  <p className="text-blue-500 text-xs mt-1 mb-4">
                    among others
                  </p>
                </div>

                <div>
                  <h3 className="text-xl font-bold text-blue-900 mb-6">
                    Awards & Recognition
                  </h3>
                  <div className="grid md:grid-cols-3 gap-6">
                    {/* Award 1 */}
                    <div className="bg-white rounded-xl p-6 border border-blue-300 shadow-sm">
                      <div className="flex items-center space-x-3 mb-3">
                        <Award className="w-6 h-6 text-blue-600" />
                        <div>
                          <h4 className="font-semibold text-blue-900">
                            Julian M. Bruner Award
                          </h4>
                          <p className="text-sm text-blue-700">
                            2024 &mdash; American Society for Surgery of the
                            Hand
                          </p>
                        </div>
                      </div>
                      <p className="text-sm text-blue-800">
                        Best Poster: "Long-term Pain Course following Primary
                        and Secondary Targeted Muscle Reinnervation"
                      </p>
                    </div>

                    {/* Award 2 */}
                    <div className="bg-white rounded-xl p-6 border border-blue-300 shadow-sm">
                      <div className="flex items-center space-x-3 mb-3">
                        <Target className="w-6 h-6 text-blue-600" />
                        <div>
                          <h4 className="font-semibold text-blue-900">
                            Jesse B. Jupiter Award
                          </h4>
                          <p className="text-sm text-blue-700">
                            2025 &mdash; Harvard Medical School & Massachusetts
                            General Hospital
                          </p>
                        </div>
                      </div>
                      <p className="text-sm text-blue-800">
                        Clinical Impact: "Machine Learning Approach to Predict
                        Pain Outcomes"
                      </p>
                    </div>

                    {/* Award 3 */}
                    <div className="bg-white rounded-xl p-6 border border-blue-300 shadow-sm">
                      <div className="flex items-center space-x-3 mb-3">
                        <Lightbulb className="w-6 h-6 text-blue-600" />
                        <div>
                          <h4 className="font-semibold text-blue-900">
                            Richard J. Smith Prize
                          </h4>
                          <p className="text-sm text-blue-700">
                            2025 &mdash; Harvard Medical School & Massachusetts
                            General Hospital
                          </p>
                        </div>
                      </div>
                      <p className="text-sm text-blue-800">
                        Best Innovation: "Combined Peripheral Nerve Surgery and
                        Stimulation"
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        );

      case "publications":
        return (
          <div className="bg-slate-50 py-16 px-6">
            <div className="max-w-6xl mx-auto">
              <div className="text-center mb-12">
                <h2 className="text-3xl font-bold text-slate-900 mb-4">
                  Scientific Publications
                </h2>
                <p className="text-lg text-slate-600">
                  Complete list of peer-reviewed research contributions (most recent
                  first)
                </p>
              </div>

              <div className="bg-white rounded-xl p-6 border border-slate-200 mb-8">
                <div className="flex justify-between items-center mb-4">
                  <h3 className="text-xl font-bold text-slate-900">
                    All Publications ({allPublications.length})
                  </h3>
                  <button
                    onClick={() => setShowAllPublications(!showAllPublications)}
                    className="flex items-center space-x-2 bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 transition-colors text-sm"
                  >
                    <span>
                      {showAllPublications ? "Show Less" : "Show All"}
                    </span>
                    <ChevronDown
                      className={`w-4 h-4 transition-transform ${
                        showAllPublications ? "rotate-180" : ""
                      }`}
                    />
                  </button>
                </div>

                <div className="space-y-4">
                  {(showAllPublications
                    ? allPublications
                    : allPublications.slice(0, 10)
                  ).map((pub, index) => (
                    <div
                      key={index}
                      className="p-4 border-2 border-slate-100 rounded-lg hover:border-blue-200 transition-colors bg-slate-50"
                    >
<h4 className="font-medium text-slate-900 mb-1">
  {pub.link ? (
    <a
      href={pub.link}
      target="_blank"
      rel="noopener noreferrer"
      className="hover:text-blue-600 transition-colors"
    >
      {pub.title}
    </a>
  ) : (
    pub.title
  )}
</h4>

{/* BADGES BELOW TITLE */}
{pub.status && (
  <div className="flex space-x-2 mb-2">
    {(Array.isArray(pub.status) ? pub.status : [pub.status]).map((s, i) => (
      <span
        key={i}
        className={`text-xs px-2 py-1 rounded ${
          s.toLowerCase() === 'in press' ? 'bg-orange-100 text-orange-800' :
          s.toLowerCase() === 'highlighted' ? 'bg-blue-100 text-blue-800' :
          s.toLowerCase() === 'accepted' ? 'bg-green-100 text-green-800' :
          s.toLowerCase() === 'submitted' ? 'bg-yellow-100 text-yellow-800' :
          s.toLowerCase() === 'preprint' ? 'bg-purple-100 text-purple-800' :
          'bg-gray-100 text-gray-800'
        }`}
      >
        {s}
      </span>
    ))}
  </div>
)}

                      <p className="text-sm text-slate-600 mb-2">
                        {pub.authors}
                      </p>
                      <div className="flex items-center space-x-4 text-sm text-slate-500">
                        <span className="font-medium">{pub.journal}</span>
                        <span>•</span>
                        <span>{pub.year}</span>
                      </div>
                    </div>
                  ))}
                </div>

                {!showAllPublications && allPublications.length > 10 && (
                  <div className="text-center mt-6">
                    <p className="text-sm text-slate-600">
                      Showing 10 of {allPublications.length} publications
                    </p>
                  </div>
                )}
              </div>
            </div>
          </div>
        );

      case "contact":
        return (
          <div className="py-16 px-6">
            <div className="max-w-4xl mx-auto">
              <div className="text-center mb-12">
                <h2 className="text-3xl font-bold text-slate-900 mb-4">
                  Contact
                </h2>
                <p className="text-lg text-slate-600 max-w-2xl mx-auto">
                  Interested in exploring opportunities in industry,
                  research collaboration, or my work in pain medicine and clinical research? 
                </p>
              </div>

              <div className="grid md:grid-cols-2 gap-8 mb-12">
                <div className="text-center">
                  <div className="inline-flex items-center justify-center w-12 h-12 bg-blue-100 rounded-xl mb-4 transform hover:-translate-y-1 transition-transform duration-300">
                    <Mail className="w-5 h-5 text-blue-600" />
                  </div>
                  <h3 className="font-semibold text-black mb-2">Email</h3>
                  <a
                    href="mailto:fraasveld@mgh.harvard.edu"
                    className="text-blue-600 hover:text-blue-700 text-sm transition-colors duration-300"
                  >
                    fraasveld@mgh.harvard.edu
                  </a>
                </div>

                <div className="text-center">
                  <div className="inline-flex items-center justify-center w-12 h-12 bg-blue-100 rounded-xl mb-4 transform hover:-translate-y-1 transition-transform duration-300">
                    <MapPin className="w-5 h-5 text-blue-600" />
                  </div>
                  <h3 className="font-semibold text-black mb-2">Location</h3>
                  <span className="text-black text-sm">Boston, MA</span>
                </div>
              </div>

              <div className="bg-slate-50 rounded-xl p-8 border border-slate-200">
                <h3 className="text-xl font-bold text-slate-900 mb-6 text-center">
                  Professional Interests
                </h3>
                <div className="grid md:grid-cols-2 gap-8">
                  <div>
                    <h4 className="font-semibold text-slate-900 mb-3">
                      Industry Sectors
                    </h4>
                    <ul className="space-y-2 text-slate-600 text-sm">
                      <li className="flex items-center space-x-2">
                        <div className="w-1.5 h-1.5 bg-blue-500 rounded-full"></div>
                        <span>Pharmaceuticals</span>
                      </li>
                      <li className="flex items-center space-x-2">
                        <div className="w-1.5 h-1.5 bg-blue-500 rounded-full"></div>
                        <span>Medical Technology & Devices</span>
                      </li>
                      <li className="flex items-center space-x-2">
                        <div className="w-1.5 h-1.5 bg-blue-500 rounded-full"></div>
                        <span>AI Clinical Prediction and Decision-making</span>
                      </li> 
                    </ul>
                  </div>
                  <div>
                    <h4 className="font-semibold text-slate-900 mb-3">
                      Collaboration Areas
                    </h4>
                    <ul className="space-y-2 text-slate-600 text-sm">
                      <li className="flex items-center space-x-2">
                        <div className="w-1.5 h-1.5 bg-blue-500 rounded-full"></div>
                        <span>Clinical research partnerships</span>
                      </li>
                      <li className="flex items-center space-x-2">
                        <div className="w-1.5 h-1.5 bg-blue-500 rounded-full"></div>
                        <span>Scientific advisory roles</span>
                      </li>
                      <li className="flex items-center space-x-2">
                        <div className="w-1.5 h-1.5 bg-blue-500 rounded-full"></div>
                        <span>Regulatory consulting</span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        );

      default:
        return null;
    }
  };

  return (
    <div className="min-h-screen bg-white">
      <nav
        className={`fixed w-full top-0 z-50 transition-all duration-300 ${
          isScrolled
            ? "bg-white shadow-sm border-b border-slate-200"
            : "bg-white/90 backdrop-blur-sm"
        }`}
      >
        <div className="max-w-6xl mx-auto px-6 py-4">
          <div className="flex justify-between items-center">
            <div className="flex items-center space-x-3">
              <div className="w-12 h-12 bg-blue-600 rounded-lg flex items-center justify-center">
                <span className="text-white font-bold text-lg">FR</span>
              </div>
              <div>
                <h1 className="text-lg font-bold text-slate-900">
                  Dr. Floris V. Raasveld
                </h1>
                <p className="text-xs text-slate-600">MD | PhD | MBA </p>
              </div>
            </div>
            <div className="hidden md:flex space-x-8">
              {["Home", "About", "Research", "Publications", "Contact"].map(
                (item) => (
                  <button
                    key={item}
                    onClick={() => navigateToSection(item.toLowerCase())}
                    className={`text-sm font-medium transition-colors ${
                      activeSection === item.toLowerCase()
                        ? "text-blue-600"
                        : "text-slate-600 hover:text-slate-900"
                    }`}
                  >
                    {item}
                  </button>
                )
              )}
            </div>
            <div className="md:hidden">
              <button
                onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
                className="p-2 text-slate-600 hover:text-slate-900"
              >
                {isMobileMenuOpen ? (
                  <X className="w-6 h-6" />
                ) : (
                  <Menu className="w-6 h-6" />
                )}
              </button>
            </div>
          </div>
          {/* Mobile Menu */}
          {isMobileMenuOpen && (
            <div className="md:hidden border-t border-slate-200 py-4">
              <div className="flex flex-col space-y-4">
                {["Home", "About", "Research", "Publications", "Contact"].map(
                  (item) => (
                    <button
                      key={item}
                      onClick={() => navigateToSection(item.toLowerCase())}
                      className={`text-left text-sm font-medium transition-colors ${
                        activeSection === item.toLowerCase()
                          ? "text-blue-600"
                          : "text-slate-600 hover:text-slate-900"
                      }`}
                    >
                      {item}
                    </button>
                  )
                )}
              </div>
            </div>
          )}
        </div>
      </nav>

      <div className="pt-24 pb-16 px-6 bg-slate-50">
        <div className="max-w-6xl mx-auto">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div className="space-y-6">
              <div className="space-y-4">
                {/* Removed the Available for Medical Affairs Opportunities box here */}
                <h1 className="text-3xl lg:text-5xl font-bold text-slate-900 leading-tight">
                  Physician-Scientist
                  <span className="block text-blue-600">Neuropathic Pain</span>
                  <span className="block text-gray-600 text-lg font-medium tracking-wide">
                    Science &nbsp;•&nbsp; Intervention &nbsp;•&nbsp; Innovation
                  </span>
                </h1>

                <p className="text-lg text-slate-600 leading-relaxed">
                  Physician and clinical researcher dedicated to neuropathic pain management, contributing to multicenter studies, evaluating novel therapies, and advancing clinical decision-making.
                </p>
              </div>

              <div className="flex flex-wrap gap-4">
                <a
                  href="/Floris_Raasveld_Resume.pdf"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="bg-gradient-to-r from-blue-600 to-indigo-600 text-white px-8 py-3 rounded-xl hover:from-blue-700 hover:to-indigo-700 transition-all duration-200 shadow-lg hover:shadow-xl transform hover:-translate-y-0.5 flex items-center space-x-2"
                >
                  <Download className="w-4 h-4" />
                  <span>Download Resume</span>
                </a>
                <button
                  onClick={() => navigateToSection("contact")}
                  className="border-2 border-blue-600 text-blue-600 px-8 py-3 rounded-xl hover:bg-blue-600 hover:text-white transition-all duration-200 shadow-lg hover:shadow-xl transform hover:-translate-y-0.5 flex items-center space-x-2"
                >
                  <Mail className="w-4 h-4" />
                  <span>Contact</span>
                </button>
              </div>

              <div className="flex items-center space-x-6 pt-4">
                <a
                  href="https://www.linkedin.com/in/floris-raasveld-646b1b151/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center space-x-2 text-slate-600 hover:text-blue-600 transition-colors text-sm"
                >
                  <Linkedin className="w-4 h-4" />
                  <span>LinkedIn</span>
                </a>
                <a
                  href="https://orcid.org/0000-0002-7566-1159"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center space-x-2 text-slate-600 hover:text-blue-600 transition-colors text-sm"
                >
                  <img
                    src="/images/ORCID-iD_icon_BW_32x32.png"
                    alt="ORCID iD"
                    className="w-4 h-4"
                  />
                  <span>ORCID</span>
                </a>
              </div>
            </div>

            <div className="relative">
              <div className="aspect-square max-w-md mx-auto relative">
                <div className="absolute inset-0 bg-slate-200 rounded-2xl transform rotate-2"></div>
                <div className="absolute inset-0 rounded-2xl shadow-lg overflow-hidden bg-slate-100">
                  <img
                    src="/images/HCB_FVR.png"
                    alt="Dr. Floris V. Raasveld presenting at Harvard Club"
                    className="w-full h-full object-cover rounded-2xl"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div id="main-content">
  {renderMainContent()}
</div>

      <footer className="bg-slate-900 text-white py-12 px-6">
        <div className="max-w-6xl mx-auto">
          <div className="grid md:grid-cols-4 gap-8 mb-8">
            <div>
              <div className="flex items-center space-x-3 mb-4">
                <div className="w-8 h-8 bg-blue-600 rounded-lg flex items-center justify-center">
                  <span className="text-white font-bold text-sm">FR</span>
                </div>
                <div>
                  <h3 className="font-bold">Dr. Floris V. Raasveld</h3>
                  <p className="text-slate-400 text-sm">Physician-Scientist</p>
                </div>
              </div>
              <p className="text-slate-400 text-sm">
                Advancing pain medicine through clinical research and
                evidence-based therapeutic development.
              </p>
            </div>

            <div>
              <h4 className="font-semibold mb-4">Professional Affiliations</h4>
              <div className="space-y-1 text-slate-400 text-sm">
                <p>Massachusetts General Hospital</p>
                <p>Harvard Medical School</p>
                <p>Erasmus University Medical Center</p>
                <p>NIH HEAL Initiative</p>
              </div>
            </div>

<div>
  <h4 className="font-semibold mb-4">Focus Areas</h4>
  <div className="space-y-1 text-slate-400 text-sm">
    <p>Clinical Research & Trials</p>
    <p>Pain Medicine & Neuroscience</p>
    <p>Translational Science</p>
    <p>Healthcare AI</p>
  </div>
</div>

            <div>
              <h4 className="font-semibold mb-4">Contact Information</h4>
              <div className="space-y-2 text-slate-400 text-sm">
                <a
                  href="mailto:fraasveld@mgh.harvard.edu"
                  className="hover:text-white transition-colors block"
                >
                  fraasveld@mgh.harvard.edu
                </a>
                <p>Boston, MA</p>
                <div className="flex space-x-4 pt-2">
                  <a
                    href="https://www.linkedin.com/in/floris-raasveld-646b1b151/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-slate-400 hover:text-white transition-colors"
                  >
                    <Linkedin className="w-4 h-4" />
                  </a>
                  <a
                    href="https://orcid.org/0000-0002-7566-1159"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-slate-400 hover:text-white transition-colors"
                  >
                    <img
                      src="/images/ORCID-iD_icon_unauth_reversed_32x32.png"
                      alt="ORCID iD"
                      className="w-4 h-4 filter brightness-0 invert opacity-60 hover:opacity-100 transition-opacity"
                    />
                  </a>
                </div>
              </div>
            </div>
          </div>

          <div className="border-t border-slate-800 pt-6 text-center text-slate-400 text-sm">
            <p>&copy; 2025 Dr. Floris V. Raasveld. All rights reserved.</p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default App;
